import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaFileExcel, FaChartBar } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, NavDropdown } from 'react-bootstrap';
import { logout } from '../services/authService';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = () => {
    const auth = useAuth() || {};
    const currentUser = auth.currentUser || null;
    const updateUser = auth.updateUser || (() => { });

    const navigate = useNavigate();
    const location = useLocation();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const handleLogout = () => {
        logout();
        updateUser(null);
        navigate('/');
    };

    const handleFAQClick = (e) => {
        e.preventDefault();

        if (location.pathname === '/') {
            const faqElement = document.getElementById('faq-section');
            if (faqElement) {
                faqElement.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            navigate('/faq');
        }
    };

    return (
        <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="top-header">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6} className="d-flex align-items-center">
                            <div className="logo-container d-flex align-items-center">
                                <Link to="/" className="logo-link">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/logo.png`}
                                        alt="OtoPrime Logo"
                                        className="logo"
                                    />
                                </Link>

                                {/* Menü öğeleri logo yanına */}
                                <ul className="inline-nav-menu">
                                    <li><Link to="/sales-system">Satış Sistemi</Link></li>
                                    <li><Link to="/about">Hakkımızda</Link></li>
                                    <li><Link to="/contact">İletişim</Link></li>
                                    <li><a href="#" onClick={handleFAQClick}>Sık Sorulan Sorular</a></li>
                                </ul>
                            </div>
                        </Col>

                        <Col md={6} className="d-flex justify-content-end align-items-center">
                            {currentUser ? (
                                <div className="greeting">
                                    <NavDropdown
                                        title={`Merhaba, ${currentUser.name || 'Kullanıcı'}`}
                                        id="user-dropdown"
                                    >

                                        <NavDropdown.Item as={Link} to="/profile">Profilim</NavDropdown.Item>

                                        {/* Admin'e özel menüler */}
                                        {currentUser.userType === 'admin' && (
                                            <>
                                                <NavDropdown.Item as={Link} to="/add-vehicle">Araç Ekle</NavDropdown.Item>
                                                <NavDropdown.Item as={Link} to="/my-vehicles">Araçlarım</NavDropdown.Item>
                                            </>
                                        )}

                                        {/* Temsilci ve Admin için rapor menüleri */}
                                        {['temsilci', 'admin'].includes(currentUser.userType) && (
                                            <>
                                                <NavDropdown.Item as={Link} to="/report-generator">
                                                    <FaFileExcel className="me-2" />
                                                    Rapor Oluştur
                                                </NavDropdown.Item>
                                                <NavDropdown.Item as={Link} to="/reports">
                                                    <FaChartBar className="me-2" />
                                                    Raporlar
                                                </NavDropdown.Item>
                                            </>
                                        )}


                                        <NavDropdown.Divider />
                                        <NavDropdown.Item onClick={handleLogout}>Çıkış Yap</NavDropdown.Item>
                                    </NavDropdown>
                                </div>
                            ) : (
                                <div className="auth-buttons">
                                    <Link
                                        to="/login"
                                        className="btn btn-custom-customer me-2"
                                    >
                                        Üye Girişi
                                    </Link>
                                    <Link
                                        to="/register"
                                        className="btn btn-custom-dealer me-2"
                                    >
                                        Kayıt Ol
                                    </Link>
                                    <Link
                                        to="/apply"
                                        className="btn btn-custom-apply"
                                    >
                                        Hemen Başvur
                                    </Link>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        </header>
    );
};

export default Header;